<template>
    <div>
         <transition name="slide-fade">
        <v-card
    v-if="edicion == false"   
    class="mx-auto"
    max-width="400"
  >
    <div class="d-flex justify-end">
        <v-btn @click.prevent="exitsingle" class="mx-2" fab dark small color="primary">
            <v-icon dark>mdi-close</v-icon>
        </v-btn>
    </div>
     <v-card-text class="text--primary">
    <div> {{datos.valor.conductor}} - {{datos.valor.asignacion}} </div>
    </v-card-text>

    <v-card-actions>
      

        

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
       <v-btn @click="dialog = !dialog" class="mx-2" fab dark small color="danger" v-on="on">
        <v-icon dark>mdi-repeat-off</v-icon>
      </v-btn>
      </template>
      <span>Remover asignación</span>
    </v-tooltip>

      
      
  

    </v-card-actions>
  </v-card>
    </transition>


    <v-dialog
      v-model="dialog"
      width="500"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Remover ( {{datos.valor.conductor}} - {{datos.valor.asignacion}} )
        </v-card-title>

        <v-card-text>
          Estas seguro que quieres Eliminar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
          
          <v-btn
            color="primary"
            text
            @click="quitarAsign"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog = !dialog"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    </div>    
</template>
<script>

import {QuitarAsignacion} from '../../../../../services/team/asignacion'

export default {
    
    props:{
        datos:''
    },

     data(){
       return {
            overlay: false,
            edicion:false,
            images:[],
            dialog: false,
       }
     },


     methods: {
         
         exitsingle(){
            this.$store.dispatch('MenuEquipo', false);
         },

         quitarAsign:function(){
             this.$store.dispatch('LoadingFetchActions', true);
                var data = new FormData;
                data.append('vehicle_id', this.datos.valor.id_vehicle);
                data.append('conductor_id', this.datos.valor.id_conductor);

                QuitarAsignacion(data).then(response=>{
                    this.$store.dispatch('GetAsign');
                    this.$store.dispatch('GetAllSelect');
                    this.$store.dispatch('LoadingFetchActions', false);
                    this.$toastr.success('Se ha removido la asignación con éxito');
                    this.$store.commit('mutation_loading_charge', false);
                    this.exitsingle();
                }).catch(errors=>{
                    console.log(errors)
                    this.exitsingle();
                    this.$store.dispatch('LoadingFetchActions', false);
                    this.$toastr.error(errors, 'Error');
                })
         }


     },
}
</script>